// extracted by mini-css-extract-plugin
export var discard = "_5b-3";
export var muiTooltipTooltip = "_5b-5";
export var notificationBar = "_5b-2";
export var saveButtonHoverSlotWrapper = "_5b-4";
export var show = "_5b-1";
export var spacer = "_5b-0";